import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { Job } from './jobs.model';

export const getJob = createAction('[Job/API] GET Job');

export const putJob = createAction(
    '[Job/API] PUT Job',
    props<{ JsonString: any }>()
);

export const loadJobs = createAction(
    '[Job/API] Load Jobs',
    props<{ Jobs: any[] }>()
);

export const addJob = createAction(
    '[Job/API] Add Job',
    props<{ Job: Job }>()
);

export const upsertJob = createAction(
    '[Job/API] Upsert Job',
    props<{ Job: Job }>()
);

export const addJobs = createAction(
    '[Job/API] Add Jobs',
    props<{ Jobs: Job[] }>()
);

export const upsertJobs = createAction(
    '[Job/API] Upsert Jobs',
    props<{ Jobs: Job[] }>()
);

export const updateJob = createAction(
    '[Job/API] Update Job',
    props<{ Job: Update<Job> }>()
);

export const updateJobs = createAction(
    '[Job/API] Update Jobs',
    props<{ Jobs: Update<Job>[] }>()
);

export const deleteJob = createAction(
    '[Job/API] Delete Job',
    props<{ id: string }>()
);

export const deleteJobs = createAction(
    '[Job/API] Delete Jobs',
    props<{ ids: string[] }>()
);

export const clearJobs = createAction('[Job/API] Clear Jobs');
